// Loader.js
import React from 'react';
import './Loader.css'; // We'll add some styles for the loader

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;